<template>
    <div class="pm">
        <el-row class="video-tree position" style="display: flex">
            <el-col :span="treespan" class="position"  style="height: 100%;min-width: 620px">
                <div class="grid-content bg-purple taskList">
                    <issued-list ref="issuedlist" @outputdata="outputdata" @openTree="openTree" @getListid="getListid"></issued-list>
                </div>
                <el-button icon="el-icon-arrow-right" class="icon right" @click="closeTree" v-show="isright"></el-button>
                <el-button icon="el-icon-arrow-left" class="icon left" @click="openTree" v-show="!isright"></el-button>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%">
                <div class="grid-content bg-purple-light tabsList">
                    <pending-list ref="pendinglist" @closeTree="closeTree" @getListid="getListid"></pending-list>
                </div>
            </el-col>
        </el-row>

        <!--dialog-->
        <div class="div cgdia">
            <el-dialog
                    width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <details-td ref="details" :Data="Data" @cancelDialog="cancelDialog" @shuaxinList="shuaxinList"></details-td>
            </el-dialog>
        </div>
        <reportdialog  ref="mydialog"   ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>
</template>


<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import issuedList from "./issuedList";
    import pendingList from "./pendingList";
    import detailsTd from "./detailsTd";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import {baseerp} from "@/utils/baseUrl";
    export default {
        components: {
            issuedList,
            pendingList,
            detailsTd,
            eDialog,
            reportdialog,
        },
        data() {
            return {
                mid:0,
                title:this.$t('saleOrder_sales_bill_of_lading'),
                activePage:"report/res/spread.vue",
                open:false,
                baseerp:"",
                treespan:24,
                rightspan:0,
                isright:false,
                dialogVisible:false,
                Data:{},

            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            outputdata(data) {
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({title:this.$t('button_export'),parm:{type:'SellRpt',mid:this.$route.meta.mid,arg:{i_gsid:data.i_gsid,dt_startdate:data.dt_startdate,dt_enddate:data.dt_enddate,vc_search:data.vc_search}},w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })

            },
            shuaxinList(){
                this.$refs.issuedlist.currentPage=1;
                this.$refs.issuedlist.vc_search='';
                this.$refs.issuedlist.getList(1);
                this.$refs.pendinglist.currentPage=1;
                this.$refs.pendinglist.vc_search='';
                this.$refs.pendinglist.getList(0);
            },
            cancelDialog(){
                this.Data={};
                this.dialogVisible=false;
            },
            getListid(row,type){
                this.dialogVisible=true;
                if(type=='LXD'){
                    this.title=this.$t('saleOrder_sales_billing')
                }else if(type=='editLXD'){
                    this.title=this.$t('saleOrder_view_contact_form')
                }else if(type=='TD'){
                    this.title=this.$t('saleOrder_edit_bill_of_lading')
                }else if(type=='LSD'){
                    this.title=this.$t('saleOrder_confirm_audit')
                }
                this.Data={
                    row:row,
                    type:type,
                }
            },
            closeTree(){
                this.treespan=24;
                this.rightspan=0;
                this.isright=false;
            },
            openTree(){
                this.treespan=15;
                this.rightspan=9;
                this.isright=true;
                this.$refs.pendinglist.currentPage=1;
                this.$refs.pendinglist.vc_search='';
                this.$refs.pendinglist.getList(0);
            },

        },
    }
</script>

<style  lang="scss" scoped>
    .pm{
        height: calc(100vh - 145px);
        /*overflow: auto;*/
    }
    .cgdia {
        //弹出层里内容 样式
        .el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 0 20px 0 20px;
        }
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        //left: -19px;
        right: 0px;
        border-right: none;
    }
    .left{
        //left: -10px;
        right: 0px;
        border-right: none;
    }
    .position{
        position: relative;
    }
    /*.fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }*/
</style>